import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  titleBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: '1rem'
  },

  title: {
    fontSize: theme.size.sm
  },

  subTitle: {
    fontSize: theme.size.sm
  },

  conversations: {
    display: 'flex',
    flexDirection: 'column',

    '& > :not(:last-child)': {
      marginBottom: '0.25rem'
    }
  },

  checkBox: {
    marginRight: '1rem'
  },

  conversation: {
    display: 'flex',
    alignItems: 'center'
  },

  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '0.75rem',

    '& > :last-child': {
      marginLeft: '0.5rem'
    }
  },

  button: {
    padding: '0.705rem 1.875rem',
    fontSize: theme.size.sm
  }
}))

export default useStyles
